import { useFieldContext } from '~/util/hooks/useFormContext';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { Input } from '~/primitives/input';
import { cn, toDatetimeLocal } from '~/util';

export function DateTimeField({
    placeholder,
    className,
    forceDisabled,
    ...labelProps
}: {
    placeholder?: string;
    forceDisabled?: boolean;
    className?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const disabled = useDisableFormContext() || forceDisabled;

    const localizedValue = field.state.value
        ? toDatetimeLocal(field.state.value)
        : '';

    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Input
                className={cn(
                    'w-fit field-sizing-content max-w-lg',
                    disabled ? 'cursor-not-allowed' : 'cursor-text',
                    className,
                )}
                id={field.name}
                placeholder={placeholder}
                required={labelProps.required}
                type="datetime-local"
                value={localizedValue}
                onChange={(e) =>
                    field.setValue(
                        new Date(e.target.value).toISOString() ?? null,
                    )
                }
                disabled={disabled}
            />
        </FieldLabelWithError>
    );
}

export function DateField({
    placeholder,
    className,
    forceDisabled,
    ...labelProps
}: {
    placeholder?: string;
    forceDisabled?: boolean;
    className?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const disabled = useDisableFormContext() || forceDisabled;

    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Input
                className={cn(
                    'w-fit field-sizing-content max-w-lg',
                    disabled ? 'cursor-not-allowed' : 'cursor-text',
                    className,
                )}
                id={field.name}
                placeholder={placeholder}
                required={labelProps.required}
                type="date"
                value={field.state.value ?? ''}
                onChange={(e) => field.setValue(e.target.value || null)}
                disabled={disabled}
            />
        </FieldLabelWithError>
    );
}
